"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = exports.StyledContent = exports.StyledActionItem = exports.StyledActionContainer = exports.StyledTextContainer = exports.StyledAlertInLine = exports.StyledContainer = exports.StyledAlertInLineWrapper = exports.StyledWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const AlertInline_types_1 = require("./AlertInline.types");
exports.StyledWrapper = styled_components_1.default.div `
  width: 100%;
  position: relative;
  box-sizing: border-box;
`;
exports.StyledAlertInLineWrapper = (0, styled_components_1.default)(exports.StyledWrapper) `
  margin-top: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.StyledContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  row-gap: ${({ theme }) => theme.sizes['4xs'].value};
  word-break: break-all;

  svg {
    flex-shrink: 0;
  }
`;
exports.StyledAlertInLine = (0, styled_components_1.default)(exports.StyledContainer) `
  background-color: ${({ color, theme }) => theme.colors.colours.system[color].value};

  padding: ${({ theme, hasTitle, hasActions, hasIcon, size }) => {
    if (hasTitle || hasActions) {
        return theme.sizes.xs.value;
    }
    if (!hasTitle && !hasActions && !hasIcon && size === AlertInline_types_1.AlertInlineSize.Compact) {
        return `${theme.sizes['4xs'].value} ${theme.sizes['2xs'].value}`;
    }
    return theme.sizes['2xs'].value;
}};
`;
exports.StyledTextContainer = styled_components_1.default.div ``;
exports.StyledActionContainer = styled_components_1.default.div `
  display: flex;
  column-gap: ${({ theme }) => theme.sizes['2xs'].value};
  justify-content: flex-end;
  box-sizing: border-box;
  height: 100%;
  align-items: center;
  margin-top: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.StyledActionItem = styled_components_1.default.div `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  button {
    text-decoration: 'underline';
  }
`;
exports.StyledContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.StyledTitle = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => theme.sizes['2xs'].value};
`;
//# sourceMappingURL=AlertInline.styled.js.map